import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderFullGeneration,
  BackendMutationGenerateFullBlogPostArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation GenerateFullBlogPost(
    $projectId: ID!
    $maxWords: Int
    $debugAcPrompt: String
    $customerPersonaId: ID
    $tovInput: TovInput
    $blogLength: Int
    $generateHeaders: Boolean
  ) {
    generateFullBlogPost(
      projectId: $projectId
      maxWords: $maxWords
      debugAcPrompt: $debugAcPrompt
      customerPersonaId: $customerPersonaId
      tovInput: $tovInput
      blogLength: $blogLength
      generateHeaders: $generateHeaders
    ) {
      id
      blogPostBuilderDraftId
    }
  }
`;

type Variables = BackendMutationGenerateFullBlogPostArgs;

type Result = Pick<BackendBlogPostBuilderFullGeneration, 'id' | 'blogPostBuilderDraftId'>;

export const generateFullBlogPost = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
